// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__VxN3q","inputWrap":"styles_inputWrap__2u7b8","input":"styles_input__10hhw"};